<template lang="pug">
.content
  .row
    //- avatar(:src='user.avatar', :fullname='user.fullname', :userquotes='user.userquotes', :cover='user.cover', :name_color='user.name_color')
    avatar(:user='user' @onUpdateAvatar="updateAvatar")
  .row
    .col-md-7.block-personal-info-left
      .card
        .card-content
          h6.title2.pull-left THÔNG TIN CÁ NHÂN
          //- i.material-icons.pull-right(v-on:click="updateProfile" style='cursor:pointer;') edit
          img.pull-right(src='../../assets/images/faces/ic_edit.svg' @click="updateProfile")
          .clearfix
          UserInfo(:user='user')
          Follow(:following="following" :followed="followed")
          .clearfix
      .card.block-activity
        .card-content
          h6.title2 HOẠT ĐỘNG GẦN ĐÂY
          .clearfix
          Activity(:user='user')
    .col-md-5.block-personal-info-right
      .card
        .card-content
          h6.title2 THÀNH TÍCH
          .clearfix
          Achieve(:user='user')
          br
          h6.title2.pull-left THÀNH TÍCH NỔI BẬT
          p.pull-right
            a.link-color(@click='routePathAchievement()') Quản lý thành tích >
          .clearfix
          Highlight(:user='user')

          h6.title2.pull-left MÔN HỌC 
            span(v-if="user.type_user === 1 || user.type_user === 3") THẾ MẠNH
            span(v-else-if="user.type_user === 2") CÓ THỂ GIẢNG DẠY
          p.pull-right
            a.link-color(href="#") Quản lý đăng ký 
              span(v-if="user.type_user === 1 || user.type_user === 3") PRO
              span  >
          .clearfix
          Strength(:user='user')

          div(v-if="user.type_user === 2")
            h6.title2.pull-left CỘNG ĐỒNG CỦA GIÁO VIÊN
            br
            CommunityTeacher

      .card.block-public
        .card-content
          h6.title2.pull-left CỘNG ĐỒNG
          p.pull-right
            a.link-color(@click="routePathPCList") Tất cả cộng đồng >
          .clearfix
          Community
       
    .col-md-7
      .card.block-activity-mobile
        .card-content
          h6.title2 HOẠT ĐỘNG GẦN ĐÂY
          .clearfix
          Activity(:user='user')

</template>
<script>
import store from '../../store'
import MdNotification from '@/core/components/mdNotification'
import Avatar from './avatar'
import UserInfo from './UserInfo'
import Follow from './Follow'
import Activity from './Activity'
import Achieve from './Achieve'
import Highlight from './Highlight'
import Strength from './Strength'
import mdUpdateProfile from './UpdateProfile'
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import Community from './Community'
import CommunityTeacher from './CommunityTeacher'

export default {
  components: {
    Avatar,
    UserInfo,
    Follow,
    Activity,
    Achieve,
    Highlight,
    Strength,
    mdUpdateProfile,
    MdNotification,
    Community,
    CommunityTeacher
  },
  data() {
    return {
      user: {},
      following: [],
      followed: [],
      force: 0
    }
  },
  methods: {
    async forceUpdate() {
      await this.force++
    },
    routePathAchievement() {
      // this.$router.replace('achievement')
    },
    routePathPCList() {
      this.$router.push('/page-public')
    },
    showNotification(messages, color, from, align, timeout) {
      this.$notifications.notify({
        'type': color,
        'icon': 'notifications',
        'message': messages,
        'placement': {
          'from': from,
          'align': align
        },
        'timeout': timeout
      })
    },
    updateProfile() {
      try {
        // console.log('==> modal edit: ', this.$modal)
        this.$modal.show(mdUpdateProfile, {
          user: this.user,
          saveEditProfile: this.onSaveProfile,
          quotesLength: this.user.userquotes ? this.user.userquotes.length : 0
        }, {
          height: 'auto',
          classes: ['col-md-6'],
          adaptive: true,
          resize: true,
          scrollable: true,
          clickToClose: false,
          reset: true,
          pivotY: 0.5 // vertical position(0-1.0)
        })
      } catch (e) {
        console.error(e)
      }
    },
    onSaveProfile(payload) {
      // console.log('===> onSaveProfile', payload)
      this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_PROFILE),
        variables: {
          uid: payload.uid,
          fullname: payload.fullname,
          userquotes: payload.userquotes,
          phone: payload.phone_number,
          name_color: payload.name_color,
          school_id: payload.school_id,
          birthday: payload.birthday,
          grade_id: '{' + payload.grade_id + '}', // format graphql array
          is_show_email: payload.is_show_email,
          is_show_phone: payload.is_show_phone,
          is_show_birthday: payload.is_show_birthday
        }
        // update: (store, { data: { updateUser } }) => {
        //   const data = store.readQuery({
        //     query: gql(graphql.GET_PROFILE),
        //     variables: {
        //       uid: payload.uid
        //     }
        //   })
        //   var userUpdated = data.users[0]
        //   var gradeArr = []
        //   gradeArr.push(payload.grade_id.toLocaleString())
        //   userUpdated.fullname = payload.fullname
        //   userUpdated.userquotes = payload.userquotes
        //   userUpdated.phone_number = payload.phone_number
        //   userUpdated.name_color = payload.name_color
        //   userUpdated.school_id = payload.school_id
        //   userUpdated.grade_id = gradeArr
        //   userUpdated.birthday = payload.birthday
        //   userUpdated.is_show_email = payload.is_show_email
        //   userUpdated.is_show_phone = payload.is_show_phone
        //   userUpdated.is_show_birthday = payload.is_show_birthday
        //   store.writeQuery({
        //     query: gql(graphql.GET_PROFILE),
        //     variables: {
        //       uid: payload.uid
        //     },
        //     data
        //   })
        // }
      }).then(res => {
        // console.log(data, typeof data)
        this.$apollo.queries.user.refetch()
        this.showNotification('Thông tin cá nhân đã được cập nhật', 'success', 'top', 'right', 5000)
        if (res && res !== null && res !== undefined) {
          var fullname = res.data.update_users.returning[0]
          store.commit('setFullname', fullname)
        }
      }).catch(e => {
        console.error(e)
        this.showNotification(e, 'danger', 'top', 'right', 5000)
      })
    },
    updateAvatar(data) {
      if (data) this.$apollo.queries.user.refetch()
    }
  },
  apollo: {
    user: {
      query: gql(graphql.GET_PROFILE),
      fetchPolicy: 'no-cache',
      variables() {
        return {
          uid: this.$store.getters.user
        }
      },
      update: data => {
        return data.users[0]
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    },
    following: {
      query: gql(graphql.GET_FOLLOWING),
      fetchPolicy: 'no-cache',
      variables() {
        return {
          uid: this.$store.getters.user
        }
      },
      update: data => {
        var nodes = data.followes_aggregate.nodes
        var lstNodes = []
        var countFollow = 0
        if (nodes) {
          for (var i = 0; i < nodes.length; i++) {
            lstNodes.push(nodes[i].userFollowed)
          }
          countFollow = data.followes_aggregate.aggregate.count
        }
        return [lstNodes, countFollow]
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    },
    followed: {
      query: gql(graphql.GET_FOLLOWED),
      fetchPolicy: 'no-cache',
      variables() {
        return {
          uid: this.$store.getters.user
        }
      },
      update: data => {
        var nodes = data.followes_aggregate.nodes
        var lstNodes = []
        var countFollow = 0
        if (nodes) {
          for (var i = 0; i < nodes.length; i++) {
            lstNodes.push(nodes[i].userFollow)
          }
          countFollow = data.followes_aggregate.aggregate.count
        }
        return [lstNodes, countFollow]
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    }
  },
  mounted () {
    // console.log('this.$route.params', this.$route.params)
    if (this.$route.params.reload !== undefined && this.$route.params.reload === 1) {
      window.location.href = this.$router.currentRoute
    }
  },
  created() {
    this.$store.commit('setIsHomePage', false)
    // TODO: RELOAD THIS PAGE WHEN LOG IN SOCIAL IN THE FIRST TIME
    if (this.$route.params.register_reload) {
      console.log('RELOAD PAGE')
      this.$router.go(0)
    }
  }
}
</script>
<style lang="scss">
.block-personal-info-left {
  margin-top: -90px;
  .card {
    .card-content {
      img {width: 16px; height: 16px; cursor: pointer;}
    }
  }
}
.block-personal-info-right {
  margin: -90px -15px;
}
.block-activity {
  margin-top: -15px;
}
.block-public {
  margin-top: -10px;
}
.block-activity-mobile {
  display: none;
}

@media (max-width: 414px) {
  .block-personal-info-left {
    .card {
      .card-content {
        img {width: 16px; height: 16px;}
      }
    }
  }
  .block-personal-info-right {
    margin: -35px 0px;
  }
  .block-activity {
    display: none;
  }
  .block-activity-mobile {
    display: block;
    margin-top: 20px;
  }
  .block-public {
    margin-top: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?fe7d20ae